(function ($) {
  $(window).on('load', function () {
    
    $('.timeline-slider .slider-wrap .slider-for').css({"opacity": 1});

    $('.timeline-slider .item-slider .slider').slick({
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      draggable: false,
      fade: true,
      dots: true,    
      speed: 800,
      asNavFor: '.timeline-slider .slider-wrap .slider-for',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            draggable: true,
            slidesToScroll: 5,
            infinite: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            draggable: true,
            slidesToScroll: 5,
            infinite: true
          }
        },
        {
          breakpoint: 595,
          settings: {
            draggable: true,
            slidesToScroll: 3,
            infinite: true
          }
        },
        {
          breakpoint: 481,
          settings: {
            infinite: true,
            slidesToScroll: 1,
          }
        }
      ]

    });


    $('.timeline-slider .slider-wrap .slider-for').slick({
      arrows: false,      
      slidesToShow: 18,
      slidesToScroll: 1,
      infinite: false,
      speed: 800,
      draggable: false,
      focusOnSelect: true,
      asNavFor: '.timeline-slider .item-slider .slider',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            slidesToShow: 18,
          }
        },
        {
          breakpoint: 992,
          settings: {
            infinite: true,
            slidesToShow: 10,
            slidesToScroll: 5,
            draggable: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            slidesToShow: 10,
            slidesToScroll: 5,
            draggable: true
          }
        },
        {
          breakpoint: 595,
          settings: {
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 3,
            draggable: true
          }
        },
        {
          breakpoint: 481,
          settings: {
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            draggable: true
          }
        }
      ]
    });
    var len = $('.timeline-slider .item-slider .slick-dots li').length;
    $('.timeline-slider .slider-wrap .next').on('click',function(e){
          $('.timeline-slider .item-slider .slick-dots li:eq('+(len-1)+')').trigger("click");
          $(this).parent().find('.prev').removeClass('slick-disabled');
          $(this).addClass('slick-disabled');
    });

    $('.timeline-slider .slider-wrap .prev').on('click',function(e){
       $('.timeline-slider .item-slider .slick-dots li:eq('+(0)+')').trigger("click");
       $(this).parent().find('.next').removeClass('slick-disabled');
       $(this).addClass('slick-disabled');
    });

    $('body .timeline-slider .slick-arrow').on('click', function () {
      var index= $('.timeline-slider .item-slider .slick-dots .slick-active').index();
      if((len-1) === index){
        $('.timeline-slider .slider-wrap .prev').removeClass('slick-disabled');
        $('.timeline-slider .slider-wrap .next').addClass('slick-disabled');
      }else if(index==0){
        $('.timeline-slider .slider-wrap .next').removeClass('slick-disabled');
        $('.timeline-slider .slider-wrap .prev').addClass('slick-disabled');
      }else{
        $('.timeline-slider .slider-wrap .prev').removeClass('slick-disabled');
        $('.timeline-slider .slider-wrap .next').removeClass('slick-disabled');
      }
      if ($('body .timeline-slider').length > 0) {
        var offset = $('body .timeline-slider .slider-wrap .slider-for .item.slick-current').offset().left;
        // console.log(offset, "====left");

        var offset1 = $('body .timeline-slider .slider-wrap .slider-for .slick-list').offset().left;
        var offset1_width = $('body .timeline-slider .slider-wrap .slider-for .slick-list').width();
        var total = offset1 + offset1_width;
        // console.log(total);
        var total_new = total - 180;

        if (offset >= total_new) {
          $('body .timeline-slider .slider-wrap .slider-for .item').siblings().removeClass('we-active');
          $('body .timeline-slider .slider-wrap .slider-for .item.slick-current').addClass('we-active');
        }
        else {
          $('body .timeline-slider .slider-wrap .slider-for .item').removeClass('we-active');
        }
      }
    });

    $('body .timeline-slider .slider-wrap .slider-for .item, body .timeline-slider .slider-wrap .slider-for .item .dots-btn').on('click', function () {
      var index= $('.timeline-slider .item-slider .slick-dots .slick-active').index();
      if((len-1) === index){
        $('.timeline-slider .slider-wrap .prev').removeClass('slick-disabled');
        $('.timeline-slider .slider-wrap .next').addClass('slick-disabled');
      }else if(index==0){
        $('.timeline-slider .slider-wrap .next').removeClass('slick-disabled');
        $('.timeline-slider .slider-wrap .prev').addClass('slick-disabled');
      }else{
        $('.timeline-slider .slider-wrap .prev').removeClass('slick-disabled');
        $('.timeline-slider .slider-wrap .next').removeClass('slick-disabled');
      }
      if ($('body .timeline-slider').length > 0) {
        var offset = $('body .timeline-slider .slider-wrap .slider-for .item.slick-current').offset().left;
        // console.log(offset, "====left");

        var offset1 = $('body .timeline-slider .slider-wrap .slider-for .slick-list').offset().left;
        var offset1_width = $('body .timeline-slider .slider-wrap .slider-for .slick-list').width();
        var total = offset1 + offset1_width;
        // console.log(total);
        var total_new = total - 180;

        if (offset >= total_new) {
          $(this).siblings().removeClass('we-active');
          $(this).addClass('we-active');
        }
        else {
          $(this).siblings().removeClass('we-active');
          $(this).removeClass('we-active');
        }
      }
    });

   
  });

})(jQuery);
